import vmClient from '../../services/vmClient';
import { Entity, EntityStringId, IEntityType, IEntity } from '../../types/entity';
import { Pdf, IPdf } from './Pdf';
import { Language, LanguageMarshaller } from 'app/constants/enums/Language';

export interface IPdfTranslation extends IEntity {
  attributes: {
    id: EntityStringId;
    language: Language;
  };
  associations: {
    pdf: IPdf;
  };
}

export type PdfTranslation = Entity<IPdfTranslation>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PdfTranslation: IEntityType<IPdfTranslation> = vmClient.defineClass({
  typeName: 'PdfTranslation',
  version: 1,
  lockable: true,
  persisted: true,
  attributes: {
    language: {
      notNull: true,
      type: Language,
      marshaller: LanguageMarshaller,
    },
  },
  associations: {
    pdf: Pdf,
  },
});
